<template>
    <div class="upload-file">
        <b-modal id="memberCardPaymentsModal" centered size="xl" no-close-on-backdrop hide-footer   :v-model="showCardPaymentsModal">
            <template #modal-header>
                <div class="member-card-payments-header text-center">
                    <h4>Card Request Payments</h4>
                    <b-button variant="close-btn" class="btn-container" @click="closeModal">
                        <i class="fas fa-times"></i>
                    </b-button>
                </div>
            </template>
            <b-container fluid>
                <div class="member-card-payments-form">
                    <div class="member-card-payments-form">
                        <div class="payment">
                            <div class="info-detail">Payment Details</div>
                            <div class="page-card p-0 table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>S.N</th>
                                            <th>Card Id</th>
                                            <th>Payer Id</th>
                                            <th>Amount</th>
                                            <th>Payment ID</th>
                                            <th>Status</th>
                                            <th>Description</th>
                                            <th>Clearing Date</th>
                                            <th>Invoice ID</th>
                                            <th>Card Status</th>
                                            <th>Cards Requested</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="repInfoPaymentDetails && repInfoPaymentDetails.length > 0">
                                            <tr v-for="(item, index) in repInfoPaymentDetails" :key="index">
                                                <td>{{++index}}</td>
                                                <td>{{item.card_id}}</td>
                                                <td>{{item.payer_id}}</td>
                                                <td>${{item.amount}}</td>
                                                <td>{{item.payment_id}}</td>
                                                <td class="text-capitalize">{{item.status}}</td>
                                                <td class="text-capitalize">{{item.payment_description}}</td>
                                                <td>{{item.clearing_date}}</td>
                                                <td>{{item.invoice_id}}</td>
                                                <td class="text-capitalize">
                                                  {{ item.card_status ? item.card_status.toLowerCase().replace(/[_ ]/g, '-') : '' }}
                                                  </td>
                                                <td>{{item.cards_requested}}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="11" class="text-center">No records found.</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </b-container>
        </b-modal>
    </div>
    </template>
    
    <script>
    import AdminApi from '@/resource/AdminApi'
    
    export default {
        name: "MemberCardPaymentsModal",
        props: {
            member: {
               required: true,
               type: Object
            },
            showCardPaymentsModal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                repInfoPaymentDetails: [],
            };
        },
        methods: {
            closeModal() {
                this.repInfoPaymentDetails = [];
                this.$emit('onCloseModal');
                this.$bvModal.hide('memberCardPaymentsModal');
            },
            getPayments(policy_id) {
                let loader = this.$loading.show();
                const url = `/api/v2/rep-info-request/get-policy-payment-details/${policy_id}`;
                AdminApi.get(url)
                    .then(({data}) => {
                        console.log(data.data);
                        this.repInfoPaymentDetails = data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify(err.response.data.message, "error");
                    })
                    .finally(() => {
                        loader.hide();
                    });
            },
        },
        computed: {
            fullName() {
                if (!this.member.first_name || !this.member.last_name) {
                    return "";
                }
                return `${this.member.first_name} ${this.member.last_name}`;
            },
        },
    
        watch: {
        showCardPaymentsModal(value) {
          if (value) {
                this.getPayments(this.member.policy_id);
          }
        },
        },
    
    };
    </script>
    
    <style>
    .status.completed {
        background: #f3ffeb;
        border: 1px solid #2ca907;
        color: #2ca907;
    }
    
    .status.in-progress,
    .status.pending {
        color: orange;
        border: 1px solid orange;
        background-color: rgb(255, 243, 222);
    }
    
    .status.canceled,
    .status.rejected {
        color: red;
        border: 1px solid red;
        background-color: #ffefef;
    }
    
    .tier-tag {
        background: #e9fbff;
        color: #04c2f1;
        width: fit-content;
        padding: 0.5rem;
    }
    
    .info-detail {
        font-weight: 500;
        color: #000;
    }
    
    .repInfoRequestDetailModal-header h4 {
        font-size: 20px;
        color: #2c3f58;
        font-weight: 600;
    }
    
    .repInfoRequestDetailModal-header p {
        font-size: 14px;
        color: #2c3f58;
    }
    
    .repInfoRequestDetailModal-header button {
        position: absolute;
        top: -15px;
        right: -15px;
        background: #fff;
        color: #000;
        border: 0;
        box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
        border-radius: 60px;
        font-size: 18px;
        width: 45px;
        height: 45px;
        align-items: center;
        justify-content: center;
        display: flex;
    }
    
    .repInfoRequestDetailModal-form label {
        display: block;
        color: #5e5e5e;
        font-size: 14px;
        margin-bottom: 8px;
        font-weight: 500;
    }
    
    .repInfoRequestDetailModal-form .custom-field {
        width: 100%;
        border: 1px solid #dce1e7;
        outline: none;
        border-radius: 6px;
        padding: 9px 15px;
        font-size: 14px;
        transition: all ease 0.6s;
    }
    
    .univ-btnEdit,
    .univ-btnEdit:focus {
        background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
        border-radius: 6px;
        color: #fff;
        outline: none;
        border: 0;
        width: 100%;
        text-align: center;
        padding: 10px 0;
        margin-top: 10px;
        transition: all ease 0.6s;
        box-shadow: inherit;
    }
    
    .modal-content {
        border: 0;
        border-radius: 15px;
    }
    
    .modal-header {
        justify-content: center;
        border: 0;
        padding: 25px 0;
        position: relative;
    }
    
    .repInfoRequestDetailModal-header .btn-container {
        position: absolute;
        top: -14px !important;
        right: -15px;
        background: #fff;
        color: #000;
        border: 0;
        box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
        border-radius: 60px;
        font-size: 18px;
        width: 45px;
        height: 45px;
        align-items: center;
        justify-content: center;
        display: flex;
    }
    
    .info-wrap-req {
        position: relative;
        background: #f7fafc;
        padding: 0.5rem 1rem 1rem 1rem;
    }
    
    .status {
        font-size: 12px;
        padding: 8px 15px;
        border-radius: 50px;
        position: absolute;
        top: -16px;
        right: 18px;
    }
    
    @media (max-width:396px) {
        .info-wrap-req {
            padding-top: 1.5rem;
        }
    }
    </style>
    